module.exports = __webpack_public_path__ + "static/media/icon-retail.df4ced61.svg";